module.exports = __webpack_public_path__ + "assets/img/finance.a8a48849.png";